import durationService from "../../../../../../../../common/utils/duration/duration.service";
import orderTranslationsHelper from "../../../../../../../../languages/order-translations.helper";

const getNewHaltingTimeLabel = (haltingTime: number) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .changeHaltingTime.newHaltingTimeTemplateText;

  const formattedHaltingTime = durationService.format(haltingTime);

  return translations.replace("#{haltingTime}", formattedHaltingTime);
};

const getNewHaltingTimeTitle = (haltingTime: number) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().changeRideEntry
      .changeHaltingTime.newHaltingTimeTemplateText;

  const formattedHaltingTime = durationService.format(haltingTime);

  return translations.replace("#{haltingTime}", formattedHaltingTime);
};

const orderDetailsHistoryEntryChangeRideContentChangeHaltingTimeHelper = {
  getNewHaltingTimeLabel,
  getNewHaltingTimeTitle,
};

export default orderDetailsHistoryEntryChangeRideContentChangeHaltingTimeHelper;
